import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }

import {computed, ref} from 'vue';
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationDialogTextarea
    from "~/operatorApplication/vue/dialogs/dialog/textarea/OperatorApplicationDialogTextarea.vue";
import {
    OperatorApplicationDialogTextareaModelInterface
} from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaModelInterface";
import FormElementFactory from "~/cabinet/vue/interface/form/elements/FormElementFactory.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import openClientById from "~/operatorApplication/ts/service/buddyList/openClientById";
import Dictionary from "~/ts/library/Dictionary";
import {__} from "~/ts/library/Translate";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";



const __default__ = {
    name: "OperatorApplicationInitiateChatForSite"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    siteId: {}
  },
  setup(__props: any) {

let props = __props;

let model = ref<{
    textarea: OperatorApplicationDialogTextareaModelInterface,
    recipientId: string,
    additionalFormValues: Dictionary<any>
}>({
    textarea: null,
    recipientId: null,
    additionalFormValues: {}
});


let answerChannel = computed<OperatorApplicationApi.OperatorApplicationAnswerChannelOpenApiModel>(() => {
    let answerChannel = null;
    if (model.value.textarea) {
        answerChannel = OperatorAccountStore.data.value.answerChannels.find(item => item.id == model.value.textarea.answerChannelId);
        if (answerChannel) {
            model.value.additionalFormValues[answerChannel.id] = {};
        }
    }
    return answerChannel;
});

let site = computed(() => {
    return props.siteId ? OperatorAccountStore.sitesDictionary.value[props.siteId] : null;
});

function clearForm() {
    model.value.recipientId = null;
    model.value.additionalFormValues = {};

    model.value.textarea.text = null;
    model.value.textarea.files = [];
    model.value.textarea.templateId = null;
}

async function send(content: OperatorApplicationApi.OperatorMessageSendContentOpenApiModel) {
    let additionalFormValues = null;
    if (answerChannel.value?.additionalFormFields?.length) {
        additionalFormValues = model.value.additionalFormValues[answerChannel.value.id];
    }
    let p: OperatorApplicationApi.OperatorInitiateChatOpenApiModel = {
        siteId: props.siteId,
        content,
        recipientId: model.value.recipientId ? model.value.recipientId : " ",
        additionalFormValues
    };

    let result = await (new OperatorApiRequest({
        url: "/message/initiateChat",
        p
    })).send();
    let clientOpened = false;
    if (result.isSuccess) {
        let data: OperatorApplicationApi.OperatorInitiateChatResultOpenApiModel = result.data;
        if (data.cc) {
            openClientById(data.cc.toString());
            clientOpened = true;
        }
        if (OperatorApplicationConfigInstance.autoClearInitiateChatForm) {
            clearForm();
        }
    }
    if (!clientOpened) {
        result.showMessage();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_unref(site))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(answerChannel) && _unref(answerChannel).initiateChatRecipientIdFormElement)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(answerChannel).initiateChatRecipientIdFormElement.descr), 1),
              _createVNode(FormElementFactory, {
                field: _unref(answerChannel).initiateChatRecipientIdFormElement,
                modelValue: _unref(model).recipientId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).recipientId) = $event))
              }, null, 8, ["field", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_unref(answerChannel) && _unref(answerChannel).additionalFormFields && _unref(answerChannel).additionalFormFields.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(answerChannel).additionalFormFields, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field.name,
                  class: "mt-4"
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(field.descr), 1),
                  _createVNode(FormElementFactory, {
                    modelValue: _unref(model).additionalFormValues[_unref(answerChannel).id][field.name],
                    "onUpdate:modelValue": ($event: any) => ((_unref(model).additionalFormValues[_unref(answerChannel).id][field.name]) = $event),
                    field: field
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "field"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(__)("Текст сообщения и канал связи")) + ": ", 1),
        _createVNode(OperatorApplicationDialogTextarea, {
          client: _unref(site).initiateChatClientMock,
          "templates-and-send-only": "",
          "suggest-templates-at-bottom": "",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(model).textarea = $event)),
          "send-function": send
        }, null, 8, ["client"]),
        _createVNode(_component_el_row, { class: "mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(OperatorApplicationConfigInstance).autoClearInitiateChatForm,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(OperatorApplicationConfigInstance).autoClearInitiateChatForm) = $event))
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Очищать автоматически после отправки ", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})